// src/components/modalForm/ModalFormContext.js
import { createContext, useContext } from 'react';

export const ModalFormContext = createContext({ variant: 'legacy' });
export const useModalForm = () => useContext(ModalFormContext);
